import { render } from "./PosterLostPet.vue?vue&type=template&id=23c76edc&scoped=true&ts=true"
import script from "./PosterLostPet.vue?vue&type=script&lang=ts"
export * from "./PosterLostPet.vue?vue&type=script&lang=ts"

import "./PosterLostPet.vue?vue&type=style&index=0&id=23c76edc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c76edc"]])

export default __exports__